import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { zodResolver } from '@hookform/resolvers/zod';

import { z } from 'zod';

import * as S from './style';
import Field from '../../Field/Field';

interface PaymentModalProps {
	closeModal: (bool: boolean) => void;
	onComplete: (data: { presentation: string; section: string }) => void;
}

interface RegisterField {
	presentation: string;
	section: string;
}

const PaymentModal = ({ closeModal, onComplete }: PaymentModalProps) => {
	const { t } = useTranslation();
	const userRegisterSchema = z.object({
		presentation: z.string(),
		section: z.string(),
	});
	const presentations = t('society.abstract.presentations', { returnObjects: true }) as { value: string; label: string }[];
	const sections = t('society.abstract.sections', { returnObjects: true }) as { value: string; label: string }[];
	const { register, handleSubmit, watch, setValue } = useForm<RegisterField>({
		resolver: zodResolver(userRegisterSchema),
		mode: 'onChange',
		defaultValues: {
			presentation: presentations[0]?.value ?? '',
			section: sections[0]?.value ?? '',
		},
	});

	const handlePresentation = (presentation: string) => {
		setValue('presentation', presentation);
	};
	const onSubmit = async (data: RegisterField) => {
		onComplete(data);
		closeModal(false);
	};
	return (
		<S.PaymentContainer onSubmit={handleSubmit(onSubmit)}>
			<S.Title>{t('society.abstract.modal.title')}</S.Title>

			<Field title="society.abstract.modal.presentation" gap="0.8rem">
				<S.PaymentContentBox>
					{presentations.map((item) => (
						<S.PaymentContent key={item.value} className={watch('presentation') === item.value ? 'active' : ''} onClick={() => handlePresentation(item.value)}>
							{item.label}
						</S.PaymentContent>
					))}
				</S.PaymentContentBox>
			</Field>

			<Field title="society.abstract.modal.section" gap="0.8rem">
				<S.GenderBox>
					{sections.map((item) => (
						<S.GenderRadio key={item.value}>
							<input type="radio" value={item.value} {...register('section')} />
							{item.label}
						</S.GenderRadio>
					))}
				</S.GenderBox>
			</Field>

			<S.PaymentButtonBox>
				<S.CancelButton type="button" onClick={() => closeModal(false)}>
					{t('common.actions.cancel')}
				</S.CancelButton>
				<S.PaymentConfirmButton type="submit">{t('common.actions.register')}</S.PaymentConfirmButton>
			</S.PaymentButtonBox>
		</S.PaymentContainer>
	);
};

export default PaymentModal;
